import {
  ExperimentsAction,
  ExperimentsTableFilterPayload,
  ExperimentsTableOptionState,
  TableFilter,
} from 'modules/experiments/types';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import { initialExperimentsTableFilterMenu } from 'modules/experiments/constants';

export const initialExperimentsTableFilterState: ExperimentsTableOptionState = {
  menuItems: initialExperimentsTableFilterMenu,
  loading: true,
  error: false,
};

export const experimentsTableFilterOptionReducer = (
  state = initialExperimentsTableFilterState,
  action?: ExperimentsAction<Record<string, unknown>, ExperimentsTableFilterPayload>,
) => {
  switch (action?.type) {
    case ActionTypes.FETCH_TABLE_FILTER_OPTION_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_TABLE_FILTER_OPTION_RESPONSE: {
      const { options, translations } = action?.payload || <ExperimentsTableFilterPayload>{};
      return {
        ...state,
        error: false,
        loading: false,
        menuItems: state.menuItems
          ?.map((item) => {
            const label = translations[item.id] || item.id;
            const itemOptions = options?.[<TableFilter>item.id] || [];
            const isItemOptionsAvailable = itemOptions.length > 0;

            return {
              ...item,
              label,
              isVisible: item.isTitle || isItemOptionsAvailable,
              options: itemOptions,
            };
          })
          .filter(({ isVisible }) => isVisible),
      };
    }

    case ActionTypes.FETCH_TABLE_FILTER_OPTION_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };

    default:
      return state;
  }
};
